import { ReverifyRequestFailureReason } from "shared/types";

export const REVERIFY_FAILURE_REASONS: Record<
  string,
  { title: string; subtitle: string }
> = {
  [ReverifyRequestFailureReason.NoAvailableIncome]: {
    title: "No income found",
    subtitle:
      "Boom couldn't find any active income source through the selected verification methods."
  }
};
